interface PageNavigationBlock {
  id?: string | null
  anchor?: string | null
  label?: string | null
  includeInPageNavigation?: boolean | null
}

export interface PageNavigationItem {
  id: string
  title: string
}

export const usePageNavigation = (blocks?: PageNavigationBlock[] | null): PageNavigationItem[] => {
  return (blocks ?? [])
    .filter((block): block is PageNavigationBlock & { id: string, label: string } =>
      !!block?.includeInPageNavigation && !!block?.id && !!block?.label
    )
    // mirrors the element id `shared/block/index.vue` renders
    .map(block => ({ id: block.anchor || block.id, title: block.label }))
}
